export const SECTION_PHASES = {
  BEFORE: 'before',
  DURING: 'during',
  AFTER: 'after',
}

const TAB_CONTENT_TYPE = 'tab'

const SECTION_TYPE_FIELDS = ['sectionType', 'phase', 'type']

const getSectionContentType = (section = {}) => {
  const contentType = section?.contentType

  if (typeof contentType === 'string') {
    return contentType.toLowerCase()
  }

  return String(contentType?.id || '').toLowerCase()
}

export const getNormalizedSectionLabel = (section = {}) => {
  if (getSectionContentType(section) === TAB_CONTENT_TYPE) {
    return ''
  }

  return String(
    section?.h2 || section?.h3 || section?.displayTitle || section?.title || '',
  ).toLowerCase()
}

const startsWithPhaseKeyword = (normalizedSectionLabel, keyword) =>
  new RegExp(`^${keyword}\\b`).test(normalizedSectionLabel)

const getSectionTypePhase = (section = {}) => {
  for (const field of SECTION_TYPE_FIELDS) {
    const value = section?.[field]

    if (typeof value !== 'string') {
      continue
    }

    const normalizedValue = value.toLowerCase()

    if (
      normalizedValue === SECTION_PHASES.BEFORE ||
      normalizedValue === SECTION_PHASES.DURING ||
      normalizedValue === SECTION_PHASES.AFTER
    ) {
      return normalizedValue
    }
  }

  return null
}

export const classifySectionPhaseLabel = normalizedSectionLabel => {
  if (
    startsWithPhaseKeyword(normalizedSectionLabel, SECTION_PHASES.BEFORE) ||
    startsWithPhaseKeyword(normalizedSectionLabel, 'prepare')
  ) {
    return SECTION_PHASES.BEFORE
  }

  if (
    startsWithPhaseKeyword(normalizedSectionLabel, SECTION_PHASES.DURING) ||
    startsWithPhaseKeyword(normalizedSectionLabel, 'teach')
  ) {
    return SECTION_PHASES.DURING
  }

  if (
    startsWithPhaseKeyword(normalizedSectionLabel, SECTION_PHASES.AFTER) ||
    startsWithPhaseKeyword(normalizedSectionLabel, 'reinforce') ||
    startsWithPhaseKeyword(normalizedSectionLabel, 'reflect')
  ) {
    return SECTION_PHASES.AFTER
  }

  return null
}

export const getSectionPhase = (section = {}) => {
  const sectionTypePhase = getSectionTypePhase(section)

  if (sectionTypePhase) {
    return sectionTypePhase
  }

  return classifySectionPhaseLabel(getNormalizedSectionLabel(section))
}
